export default "https://static.wetvinfo.com/tv/linux/static/media/bofang_v.png";